<template>
  <div id="app">
    <el-container>
      <!-- <el-header>Header</el-header> -->
      <el-main>
        <!--路由占位符-->
        <router-view></router-view>
      </el-main>
      <el-footer>
        <!-- 引用子组件 -->
        <Footer></Footer>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import Footer from './components/footer.vue'
export default {
  name: 'app',
  components: {
    Footer
  },
  created() {
    this.$nextTick(() => {
      // 禁用右键
      // eslint-disable-next-line no-new-func
      // document.oncontextmenu = new Function('event.returnValue=false')
      // 禁用选择
      // eslint-disable-next-line no-new-func
      // document.onselectstart = new Function('event.returnValue=false')
    })
  }
}
</script>

<style lang="less" scoped>
.el-header,
.el-main,
.el-footer {
  padding: 0;
}
</style>
